import script from "./JobCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobCard.vue?vue&type=script&lang=ts&setup=true"

import "./JobCard.vue?vue&type=style&index=0&id=43f78dbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f78dbe"]])

export default __exports__